import { render, staticRenderFns } from "./TopLevelTag.vue?vue&type=template&id=ab1384f4&scoped=true&"
import script from "./TopLevelTag.vue?vue&type=script&lang=js&"
export * from "./TopLevelTag.vue?vue&type=script&lang=js&"
import style0 from "./TopLevelTag.vue?vue&type=style&index=0&id=ab1384f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1384f4",
  null
  
)

export default component.exports